import React from 'react'
import { Box, Typography, CircularProgress } from '@mui/material'
import { useSpeedtest } from '../../hooks/useSpeedtest'

const SpeedtestStatus: React.FC = () => {
  const { metrics, loading } = useSpeedtest()

  if (loading && !metrics) {
    // Prima încărcare - afișăm loading
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <CircularProgress size={10} />
      </Box>
    )
  }

  if (!metrics) {
    // Nu afișăm nimic dacă nu avem metrics
    return null
  }

  const getStatusColor = (status: 'slow' | 'medium' | 'fast') => {
    switch (status) {
      case 'slow':
        return 'error.main' // Roșu
      case 'medium':
        return 'warning.main' // Galben
      case 'fast':
        return 'success.main' // Verde
      default:
        return 'text.secondary'
    }
  }

  const getStatusLabel = (status: 'slow' | 'medium' | 'fast') => {
    switch (status) {
      case 'slow':
        return 'Slab'
      case 'medium':
        return 'Medie'
      case 'fast':
        return 'Rapidă'
      default:
        return 'Necunoscut'
    }
  }

  const statusColor = getStatusColor(metrics.status)
  const statusLabel = getStatusLabel(metrics.status)

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: statusColor,
          flexShrink: 0,
        }}
      />
      <Typography
        variant="body2"
        sx={{
          fontSize: '0.7rem',
          color: statusColor,
          fontWeight: 500,
        }}
      >
        {statusLabel} ({metrics.latency}ms, {metrics.throughput} Mbps)
      </Typography>
    </Box>
  )
}

export default SpeedtestStatus

